import React, { useState } from 'react';
import { ICartGroup } from '../../../interfaces';
import Preloader from '../../../../../../ui/svg/common/preloader';
import { selectCartGroup } from '../../../data/data-service';
import { getLocalData } from '../../../domain/shopping-cart-address-provider';
import { rootActions, useAppDispatch, useAppSelector } from '../../../data/store';

interface IEnableDisableCheckbox {
    group: ICartGroup,
    name: string,
}

const GroupRadio = (props: IEnableDisableCheckbox) => {

    const [loading, setLoading] = useState(false);
    const { group, name } = props;

    const dispatch = useAppDispatch();
    const cartData = useAppSelector(store => store.root.cartData);

    const changeGroup = async () => {

        setLoading(true);
        const response =  await selectCartGroup(group.cartGroupID, getLocalData());
        setLoading(false);

        if(!response || response.statusCode !== 200 || !response.data.isValid || !response.data.relatedData) return;

        dispatch(
            rootActions.setCartData(response.data.relatedData)
        );
    };

    return (
        <>
            {
                !loading &&
                <label className="flex items-center">
                    <input
                        type="radio"
                        name={ name }
                        className="mr-4"
                        value={ group.cartGroupID }
                        checked={ group.cartGroupID === cartData.cartGroupID }
                        onChange={ changeGroup }
                    />
                    { group.groupName }
                </label>
            }

            {
                loading &&
                <div className="mr-4 inline-block"><Preloader width="15px" height="15px" color="#4f4f4f" /></div>
            }
        </>
    )
};

export default GroupRadio;